import React, {useState,useEffect,useContext} from 'react'

import {Alert, Button, DatePicker, Form, Input, Layout, Modal, Select, Space, Spin, Table} from "antd";

import {errorN, successN, warningN} from "../../general";
import {navigate} from "hookrouter";
import useFetch from "use-http";
import {EditOutlined, UndoOutlined} from '@ant-design/icons'
import {isMobile} from "react-device-detect";

import {Context} from "../../store"
import moment from 'moment'
import {getChannelAccess, getSyncPause, isChannelAdmin} from "./channelAccess";

const {Content} = Layout;
const {Option} = Select;

// Without a room count for a type, values above this only get a warning.
const WARN_LIMIT = 50;

// Online Availability Manual Override, matches Windows frmAdmin_ChannelManualOverride.cs.
function ManualOverride(props) {
    const [state] = useContext(Context)
    const { get, post, put, response, loading} = useFetch()

    const [property, setProperty] = useState(null)
    const [propertyList, setPropertyList] = useState([])
    const [startDate, setStartDate] = useState(moment().startOf('day'))
    const [endDate, setEndDate] = useState(moment().startOf('day').add(1, 'days'))

    const [rows, setRows] = useState([])
    const [dates, setDates] = useState([])
    const [loaded, setLoaded] = useState(null)
    const [pending, setPending] = useState({})
    const [drafts, setDrafts] = useState({})
    const [saving, setSaving] = useState(false)

    const access = getChannelAccess(state.role);
    const admin = isChannelAdmin(state.role !== undefined && state.role !== null && state.role !== '' ? state.role : localStorage.getItem('role'));
    const syncPause = getSyncPause();
    const pendingCount = Object.keys(pending).length;

    useEffect(() => {

        if(localStorage.getItem('session') === null)
        {
            navigate('/')
        }
        else
        {
            let current = JSON.parse(localStorage.getItem('currentproperty'));
            let list = [];

            try
            {
                list = JSON.parse(localStorage.getItem('properties'));
            }
            catch (err)
            {
                list = [];
            }

            if(list === undefined || list === null || !Array.isArray(list))
            {
                list = [];
            }

            if(current !== null && !list.some(x => x.id.toString() === current.id.toString()))
            {
                list.push(current);
            }

            setPropertyList(list);
            setProperty(current !== null ? current.id : null);
        }

        return () => {

        }
    },[state.currentproperty])

    function clearGrid() {
        setPending({});
        setDrafts({});
        setRows([]);
        setDates([]);
        setLoaded(null);
    }

    // Changing property or dates throws away pending changes, so ask first.
    function confirmDiscard(apply) {
        if(pendingCount === 0)
        {
            apply();
            return;
        }

        Modal.confirm({
            title: 'Discard pending changes?',
            content: `You have ${pendingCount} unsaved change(s). They will be lost.`,
            okText: 'Discard',
            cancelText: 'Keep',
            onOk: () => {
                clearGrid();
                apply();
            }
        });
    }

    function onPropertyChange(e) {
        confirmDiscard(() => { setProperty(e); clearGrid(); });
    }

    function onStartChange(e) {
        if(e === null) return;
        confirmDiscard(() => { setStartDate(e.clone().startOf('day')); clearGrid(); });
    }

    function onEndChange(e) {
        if(e === null) return;
        confirmDiscard(() => { setEndDate(e.clone().startOf('day')); clearGrid(); });
    }

    function handleError(title) {
        if(response.status === 401)
        {
            localStorage.removeItem('session');
            window.location.reload();
        }
        else
        {
            errorN(`${title} - ${response.status}: ${response.statusText}. Please contact the administrator.`);
        }
    }

    async function loadData(hotel, s, e) {

        if(hotel === null || hotel === undefined)
        {
            errorN(`Please choose a property.`);
            return;
        }

        if(e.isBefore(s, 'day'))
        {
            errorN(`End date must be on or after the start date.`);
            return;
        }

        let start = s.format('YYYY-MM-DD');
        let end = e.clone().add(1, 'days').format('YYYY-MM-DD');

        let ls = [];
        for (let d = s.clone(); !d.isAfter(e, 'day'); d.add(1, 'days'))
        {
            ls.push(d.format('YYYY-MM-DD'));
        }

        try
        {
            let availabilityList = await get(`/api/channel/available?start=${start}&end=${end}&hotel=${hotel}`)
            if (!response.ok)
            {
                handleError('Load Data');
                return;
            }

            let it = await get(`/api/hotels/${hotel}/items`)
            if (!response.ok)
            {
                handleError('Load Item Data');
                return;
            }

            // room count per type, used to block values above the number of rooms
            let roomCount = {};
            let roomList = await get(`/api/hotels/${hotel}/rooms`)
            if (response.ok && Array.isArray(roomList))
            {
                for(let r of roomList)
                {
                    if(r.item !== undefined && r.item !== null)
                    {
                        roomCount[r.item.toString()] = (roomCount[r.item.toString()] || 0) + 1;
                    }
                }
            }

            let list = [];

            for(let item of (availabilityList || []))
            {
                let row = {
                    id: item.id,
                    name: '',
                    rooms: roomCount[item.id.toString()] || 0,
                    cells: {}
                };

                for(let its of (it || []))
                {
                    if(its.id.toString() === item.id.toString())
                    {
                        row.name = its.data.name;
                    }
                }

                for(let x = 0; x < ls.length; x++)
                {
                    row.cells[ls[x]] = {
                        avail: item.avail !== undefined && item.avail !== null ? item.avail[x] : undefined,
                        availRatri: item.availRatri !== undefined && item.availRatri !== null ? item.availRatri[x] : undefined
                    };
                }

                list.push(row);
            }

            setDates(ls);
            setRows(list);
            setPending({});
            setDrafts({});
            setLoaded({hotel: hotel, start: s.clone(), end: e.clone()});
        }
        catch(err)
        {
            errorN(`Error Load Data: ${err}. Please contact the administrator.`);
        }
    }

    function onLoad() {
        confirmDiscard(() => { loadData(property, startDate, endDate); });
    }

    // Windows only lets a cell be edited when Ratri itself has no rooms left for that type and date.
    function isEditable(cell) {
        return cell !== undefined && cell.avail !== undefined && cell.avail !== null &&
            cell.availRatri !== undefined && cell.availRatri !== null && cell.availRatri < 1;
    }

    function commitCell(row, date) {
        let key = `${row.id}|${date}`;
        if(drafts[key] === undefined)
        {
            return;
        }

        let text = drafts[key].trim();
        let nextDrafts = {...drafts};
        delete nextDrafts[key];
        setDrafts(nextDrafts);

        let cell = row.cells[date];

        if(!/^\d+$/.test(text))
        {
            errorN(`Value is not numeric. Please enter a whole number of 0 or more.`);
            return;
        }

        let value = parseInt(text, 10);

        if(row.rooms > 0 && value > row.rooms)
        {
            errorN(`${row.name} has only ${row.rooms} room(s). ${value} is not allowed.`);
            return;
        }

        if(row.rooms === 0 && value > WARN_LIMIT)
        {
            warningN(`${value} is a large availability for ${row.name}. Please check it before saving.`);
        }

        let next = {...pending};

        if(value === cell.avail)
        {
            delete next[key];
        }
        else
        {
            next[key] = {
                id: row.id,
                name: row.name,
                date: date,
                from: cell.avail,
                to: value
            };
        }

        setPending(next);
    }

    function undoCell(key) {
        let next = {...pending};
        delete next[key];
        setPending(next);

        let nextDrafts = {...drafts};
        delete nextDrafts[key];
        setDrafts(nextDrafts);
    }

    function onSave() {
        if(pendingCount === 0 || loaded === null)
        {
            return;
        }

        if(Object.keys(drafts).length > 0)
        {
            errorN(`Please finish editing the cell (press Enter) before saving.`);
            return;
        }

        let changes = Object.values(pending).sort((a, b) => a.name.localeCompare(b.name) || a.date.localeCompare(b.date));
        let latest = changes.map(c => c.date).sort()[changes.length - 1];

        Modal.confirm({
            title: `Push ${changes.length} availability change(s) to the channel?`,
            width: isMobile === true ? '100%' : 560,
            content: (
                <div>
                    <div style={{maxHeight: '45vh', overflow: 'auto'}}>
                        {changes.map(c => <div key={`${c.id}|${c.date}`}>{`${c.name} (${c.id}), ${moment(c.date).format('DD/MM/YYYY')}: ${c.from} -> ${c.to}`}</div>)}
                    </div>
                    <Alert style={{marginTop: '10px'}} type="warning" showIcon message={`Channel sync will be paused until ${moment(latest).format('DD/MM/YYYY')}.`} />
                </div>
            ),
            okText: 'Save',
            cancelText: 'Cancel',
            onOk: () => saveData(changes, latest)
        });
    }

    // After a push Windows pauses the channel sync up to the latest changed date (stopSync).
    async function pauseSync(hotel, latest) {
        let settingList = await get(`/api/hotels/${hotel}/settings`)
        if (!response.ok)
        {
            return `read settings ${response.status}: ${response.statusText}`;
        }

        let record = (settingList || []).find(x => x.type === 'channel');
        if (record === undefined || record === null)
        {
            return `no channel setting found for this property`;
        }

        let fresh = await get(`/api/settings/${record.id}`)
        if (!response.ok)
        {
            return `read channel setting ${response.status}: ${response.statusText}`;
        }

        if (fresh === null || fresh === undefined || fresh.id !== record.id || fresh.type !== 'channel' || fresh.data === null || fresh.data === undefined)
        {
            return `unexpected channel setting returned`;
        }

        let stopSync = fresh.data.stopSync;
        let needed = stopSync === undefined || stopSync === null || stopSync.disableSync !== true ||
            stopSync.toDate === undefined || stopSync.toDate === null || !moment(stopSync.toDate).isValid() ||
            moment(stopSync.toDate).isBefore(moment(latest), 'day');

        if (needed)
        {
            fresh.data.stopSync = {
                disableSync: true,
                toDate: latest
            };

            let saved = await put(`/api/settings/${record.id}`, fresh)
            if (!response.ok)
            {
                return `save channel setting ${response.status}: ${response.statusText}`;
            }

            fresh = saved !== null && saved !== undefined && saved.data !== undefined ? saved : fresh;
        }

        let current = JSON.parse(localStorage.getItem('currentproperty'));
        if (current !== null && current.id.toString() === hotel.toString())
        {
            localStorage.setItem('channelsetting', JSON.stringify(fresh));
        }

        return null;
    }

    async function saveData(changes, latest) {
        if(saving === true)
        {
            return;
        }

        setSaving(true);

        let body = {
            avail: changes.map(c => ({id: c.id, avail: c.to, date: c.date})),
            hotel: parseInt(loaded.hotel),
            start: loaded.start.format('YYYY-MM-DD'),
            end: loaded.end.format('YYYY-MM-DD')
        };

        let pushed = false;

        try
        {
            await post(`/api/channel/available`, body)
            if (response.ok)
            {
                pushed = true;
            }
            else
            {
                if(response.status === 401)
                {
                    localStorage.removeItem('session');
                    window.location.reload();
                    return;
                }

                errorN(`Save - ${response.status}: ${response.statusText}. Nothing was changed. Please contact the administrator.`);
            }
        }
        catch(err)
        {
            errorN(`Error Save: ${err}. Please contact the administrator.`);
        }

        if(pushed === true)
        {
            let failed = null;

            try
            {
                failed = await pauseSync(loaded.hotel, latest);
            }
            catch(err)
            {
                failed = `${err}`;
            }

            if(failed === null)
            {
                successN(`Online Availability Manual Override: ${changes.length} change(s) saved. Channel sync paused until ${moment(latest).format('DD/MM/YYYY')}.`);
            }
            else
            {
                Modal.error({
                    title: 'Availability pushed, but the pause date was not saved',
                    content: `The ${changes.length} availability change(s) were sent to the channel, but channel sync could not be paused until ${moment(latest).format('DD/MM/YYYY')} (${failed}). The next sync may overwrite them. Please contact the administrator.`
                });
            }
        }

        setSaving(false);
        await loadData(loaded.hotel, loaded.start, loaded.end);
    }

    let columns = [
        {title: 'ID', dataIndex: 'id', key: 'id', fixed: 'left', width: 60},
        {title: 'Room Type', dataIndex: 'name', key: 'name', fixed: 'left', width: 160},
    ];

    for(let date of dates)
    {
        columns.push({
            title: moment(date).format('DD/MM ddd'),
            key: date,
            width: 95,
            align: 'center',
            onCell: (row) => ({
                style: {
                    background: pending[`${row.id}|${date}`] !== undefined ? '#ffe58f' : (isEditable(row.cells[date]) ? '#bae7ff' : undefined)
                }
            }),
            render: (text, row) => {
                let cell = row.cells[date];
                if(cell === undefined || cell.avail === undefined || cell.avail === null)
                {
                    return '-';
                }

                let key = `${row.id}|${date}`;
                let change = pending[key];

                if(!isEditable(cell))
                {
                    return <span title={`Ratri avail: ${cell.availRatri}`}>{cell.avail}</span>;
                }

                return (
                    <div title={`Ratri avail: ${cell.availRatri}`}>
                        <Input
                            size="small"
                            style={{width: '55px', textAlign: 'center'}}
                            disabled={saving}
                            value={drafts[key] !== undefined ? drafts[key] : (change !== undefined ? change.to : cell.avail)}
                            onChange={(ev) => setDrafts({...drafts, [key]: ev.target.value})}
                            onBlur={() => commitCell(row, date)}
                            onPressEnter={() => commitCell(row, date)}
                        />
                        {change !== undefined ?
                            <div style={{fontSize: '9px'}}>
                                {`${change.from} -> ${change.to} `}
                                <UndoOutlined title="Undo" style={{cursor: 'pointer'}} onClick={() => undoCell(key)} />
                            </div>
                            : null
                        }
                    </div>
                );
            }
        });
    }

    if(access.availabilityManualOverride !== true)
    {
        return (
            <>
                <div style={{ backgroundImage:`url("/header-bg7.png")`, color:'black', fontSize: '18px', paddingLeft: '15px', paddingTop: '15px',paddingBottom: '15px',marginTop: '0px'}}>
                    &nbsp;&nbsp;<EditOutlined />
                    &nbsp;&nbsp;Online Availability Manual Override
                </div>
                <div style={{padding: '20px'}}>
                    <Alert type="error" showIcon message="You do not have access to Online Availability Manual Override." />
                </div>
            </>
        );
    }

    return (
        <>
        <div style={{ backgroundImage:`url("/header-bg7.png")`, color:'black', fontSize: '18px', paddingLeft: '15px', paddingTop: '15px',paddingBottom: '15px',marginTop: '0px'}}>
        &nbsp;&nbsp;<EditOutlined />
        &nbsp;&nbsp;Online Availability Manual Override
        </div>
        <Layout style={{height: isMobile === true ? '70vh':'74vh'}}>

            <Spin spinning={loading || saving}>
            <Content>
                <div style={{padding: '20px', margin: '0px 0',height:'72vh',overflow:'auto'}}>

                    {syncPause !== null ?
                        <Alert style={{marginBottom: '10px'}} type="warning" showIcon message={`Channel sync is paused until ${syncPause}`} />
                        : null
                    }

                    <Form layout="vertical">
                        <Space wrap>
                            <Form.Item label="Property">
                                <Select
                                    style={{minWidth: '220px'}}
                                    value={property}
                                    disabled={!admin}
                                    onChange={onPropertyChange}
                                    showSearch
                                    optionFilterProp="children"
                                    placeholder="Property">
                                    {propertyList.map(value => <Option key={value.id} value={value.id}>{value.name}</Option>)}
                                </Select>
                            </Form.Item>

                            <Form.Item label="Start Date">
                                <DatePicker value={startDate} onChange={onStartChange} allowClear={false} format="DD/MM/YYYY" />
                            </Form.Item>

                            <Form.Item label="End Date">
                                <DatePicker value={endDate} onChange={onEndChange} allowClear={false} format="DD/MM/YYYY" />
                            </Form.Item>

                            <Button style={{marginTop:'7px'}} onClick={onLoad} type="primary" disabled={saving}>Load</Button>

                            <Button style={{marginTop:'7px'}} onClick={onSave} type="primary" danger disabled={pendingCount === 0 || saving} loading={saving}>
                                {`Save${pendingCount > 0 ? ` (${pendingCount})` : ''}`}
                            </Button>
                        </Space>
                    </Form>

                    <div style={{fontSize: '11px', color: '#888', marginBottom: '8px'}}>
                        <span style={{display: 'inline-block', width: '12px', height: '12px', background: '#bae7ff', verticalAlign: 'middle', marginRight: '4px'}}></span>
                        Editable: Ratri has no rooms left for that type and date, so you can set the channel availability by hand.
                        &nbsp;&nbsp;
                        <span style={{display: 'inline-block', width: '12px', height: '12px', background: '#ffe58f', verticalAlign: 'middle', marginRight: '4px'}}></span>
                        Changed, not saved yet. Other cells are read-only. Nothing is sent until you press Save.
                    </div>

                    <Table dataSource={rows} columns={columns} rowKey="id" loading={loading}
                           scroll={{ x: 250 + (dates.length * 95)}}
                           bordered
                           size="small"
                           pagination={false}
                    >
                    </Table>

                </div>
            </Content>
            </Spin>
        </Layout>
        </>
    );
}

export default ManualOverride
